export default __webpack_public_path__ + "static/media/IMG_9009 copie.04c84c52.jpg";